import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: 20,
    color: theme.palette.neutral400,
  },
  body: {
    fontWeight: 400,
    fontSize: 14,
    color: theme.palette.neutral400,
  },
  dialog: {
    "& .MuiPaper-rounded": {
      borderRadius: "12px",
    },
    "& .MuiDialog-paper": {
      margin: theme.spacing(2),
      [theme.breakpoints.down("xs")]: {
        margin: theme.spacing(1),
        width: `calc(100% - ${theme.spacing(2)}px)`,
        maxWidth: "none",
      },
    },
    "& .MuiDialogActions-root": {
      flexWrap: "wrap",
      gap: theme.spacing(1),
      padding: theme.spacing(2, 3),
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column-reverse",
        alignItems: "stretch",
        padding: theme.spacing(2),
        "& > *": {
          width: "100%",
          margin: "0 !important",
        },
      },
    },
  },
}))

export default useStyles
